import { render } from "./SSHCollectorDetails.vue?vue&type=template&id=353d9064"
import script from "./SSHCollectorDetails.vue?vue&type=script&lang=js"
export * from "./SSHCollectorDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__